enum TopicType {
  GAUGE = "gauge",
  TEXT = "text",
  HIDDEN = "hidden",
  REASON = "reason",
  PROGRESS = "progress",
  ALARM = "alarm",
}
export default TopicType;
